import React from "react"
import ReactDOM from "react-dom"

import { ErrorPageComponent } from "../ErrorPageComponent"
import { loadSkin } from "./startup.js"

import "@cirrus/legacy/vendor-bower/bootstrap/less/bootstrap.less"
import "@cirrus/legacy/less/author/eas-theme-new.less"
import "@cirrus/legacy/app-common/single-form/styles.less"

const renderApp = () => {
  ReactDOM.render(
    <ErrorPageComponent
      title="Page not found"
      message="The page you are looking for doesn't exist or an other error occurred."
    />,
    document.getElementById("content-region"),
  )
}

$(document).ready(() => {
  loadSkin().then(renderApp).catch(renderApp)
})
